import { render, staticRenderFns } from "./CopyStakeWhitelistTable.vue?vue&type=template&id=258a65af&scoped=true&lang=pug"
import script from "./CopyStakeWhitelistTable.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWhitelistTable.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeWhitelistTable.vue?vue&type=style&index=0&id=258a65af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258a65af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSwitch})
